import { render } from "./Zelle.vue?vue&type=template&id=00a6ff08&scoped=true"
import script from "./Zelle.vue?vue&type=script&lang=js"
export * from "./Zelle.vue?vue&type=script&lang=js"

import "./Zelle.vue?vue&type=style&index=0&id=00a6ff08&scoped=true&lang=scss"

import exportComponent from "/var/www/gl_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a6ff08"]])

export default __exports__